
import { Link } from 'react-router-dom';

export default function QuickFAQSection() {
  const faqs = [
    {
      question: '搬家前要準備什麼？',
      answer: '搬家前建議提前 4-6 週開始準備：盤點物品、斷捨離、收集紙箱、預約搬家公司、辦理水電過戶、通知地址變更。完整準備清單讓搬家順利 80% 以上！',
      icon: 'ri-checkbox-circle-line',
      color: 'teal',
      articleId: 104
    },
    {
      question: '搬家公司怎麼選？',
      answer: '選擇搬家公司 10 大關鍵：合法登記、經營年資、網路評價、報價透明、服務內容、保險理賠、車輛設備、人員素質、溝通順暢、合約保障。建鈞搬家 Google 評價 4.9 星！',
      icon: 'ri-building-2-line',
      color: 'emerald',
      articleId: 105
    },
    {
      question: '搬家要多少錢？',
      answer: '2026 年搬家費用行情：套房 3,500-6,000 元、兩房 6,000-12,000 元、三房 12,000-20,000 元。費用依樓層、距離、物品數量而定，建鈞提供免費到府估價！',
      icon: 'ri-money-dollar-circle-line',
      color: 'amber',
      articleId: 106
    },
    {
      question: '搬家當天要注意什麼？',
      answer: '搬家當天重點：提前準備隨身包、確認物品清單、全程監督搬運、指導物品定位、驗收確認無損、支付費用索取收據。貴重物品務必自己攜帶！',
      icon: 'ri-calendar-check-line',
      color: 'orange',
      articleId: 107
    },
    {
      question: '搬家怎麼省錢？',
      answer: '15 個省錢技巧：斷捨離減量、選平日淡季、自己打包、免費紙箱、比較報價、併車服務、選適當車型。掌握技巧可省 30-50% 費用！',
      icon: 'ri-wallet-3-line',
      color: 'green',
      articleId: 108
    },
    {
      question: '搬家東西壞掉怎麼賠？',
      answer: '物品損壞處理：當場拍照記錄、向搬家公司反映、填寫理賠申請、提供購買證明。建鈞搬家提供全程保險，7 天內完成理賠程序！',
      icon: 'ri-shield-check-line',
      color: 'blue',
      articleId: 21
    }
  ];

  const colorClasses: Record<string, { bg: string; text: string; border: string }> = {
    teal: { bg: 'bg-teal-100', text: 'text-teal-600', border: 'hover:border-teal-300' },
    emerald: { bg: 'bg-emerald-100', text: 'text-emerald-600', border: 'hover:border-emerald-300' },
    amber: { bg: 'bg-amber-100', text: 'text-amber-600', border: 'hover:border-amber-300' },
    orange: { bg: 'bg-orange-100', text: 'text-orange-600', border: 'hover:border-orange-300' },
    green: { bg: 'bg-green-100', text: 'text-green-600', border: 'hover:border-green-300' },
    blue: { bg: 'bg-blue-100', text: 'text-blue-600', border: 'hover:border-blue-300' }
  };

  return (
    <section className="py-12 md:py-20 bg-gradient-to-br from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block bg-teal-100 text-teal-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-voice-recognition-line mr-2"></i>
            AI 口語化搜尋優化
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            <strong>搬家常見問題</strong> - 快速解答
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 px-4">
            最多人問的<strong>搬家問題</strong>，點擊查看完整攻略
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {faqs.map((faq, index) => (
            <Link 
              key={index}
              to={`/knowledge/article/${faq.articleId}`}
              className={`bg-white rounded-xl p-6 md:p-8 shadow-md hover:shadow-xl transition-all border border-gray-100 ${colorClasses[faq.color].border} group cursor-pointer block`}
            >
              <div className="flex items-start gap-4 mb-4">
                <div className={`${colorClasses[faq.color].bg} w-12 h-12 rounded-full flex items-center justify-center flex-shrink-0`}>
                  <i className={`${faq.icon} ${colorClasses[faq.color].text} text-2xl`}></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-gray-900 leading-tight group-hover:text-teal-600 transition-colors">
                  {faq.question}
                </h3>
              </div>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4">
                {faq.answer}
              </p>
              <div className="flex items-center text-teal-600 font-medium text-sm group-hover:translate-x-1 transition-transform">
                <span>查看完整文章</span>
                <i className="ri-arrow-right-line ml-1"></i>
              </div>
            </Link>
          ))}
        </div>

        {/* 相關搜尋關鍵字 */}
        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-3">相關搜尋：</p>
          <div className="flex flex-wrap justify-center gap-2">
            {['搬家前要準備什麼', '搬家公司怎麼選', '搬家要多少錢', '搬家當天注意事項', '搬家省錢技巧', '搬家理賠流程'].map((keyword, index) => (
              <span key={index} className="px-3 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
                {keyword}
              </span>
            ))}
          </div>
        </div>

        {/* CTA 區塊 */}
        <div className="mt-12 bg-gradient-to-r from-teal-500 to-emerald-500 rounded-2xl p-6 md:p-8 text-center shadow-xl">
          <div className="max-w-2xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4">
              還有其他問題？
            </h3>
            <p className="text-white/90 text-base md:text-lg mb-6">
              加入官方 LINE 或查看完整 FAQ，讓專業顧問為您解答所有搬家疑問！
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="https://line.me/ti/p/@285yavdh"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-white text-teal-600 px-8 py-4 rounded-full text-lg font-bold hover:bg-gray-50 transition-all cursor-pointer shadow-lg hover:shadow-2xl hover:scale-105 whitespace-nowrap"
              >
                <img 
                  src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                  alt="LINE" 
                  className="w-6 h-6"
                  loading="lazy"
                />
                <span>LINE 即時諮詢</span>
              </a>
              <Link 
                to="/faq"
                className="inline-flex items-center justify-center gap-2 bg-teal-700 text-white px-8 py-4 rounded-full text-lg font-bold hover:bg-teal-800 transition-all cursor-pointer shadow-lg hover:shadow-2xl hover:scale-105 whitespace-nowrap"
              >
                <i className="ri-question-line text-2xl"></i>
                <span>查看完整 FAQ</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
